import React from "react";
import { EXT_URLS } from "../../../constants/urls";
import { Link } from "@one-thd/sui-atomic-components";

export const LegalText = () => {
  const TermsOfUse = () => (
    <Link className="two-factor-legal-text" href={EXT_URLS.TERMS} target="_blank" rel="noopener noreferrer">
      Terms of Use
    </Link>
  );
  const PrivacyPolicy = () => (
    <Link className="two-factor-legal-text" href={EXT_URLS.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </Link>
  );

  return (
    <div className="security-info-column u__legal u__text-align--left">
      <div className="col__12-12 padding-none u--paddingTiny-vertical">
        Message and data rates may apply.
      </div>
      <div className="col__12-12 padding-none">
        <span className="u--paddingSmall-right">
          <TermsOfUse/>
        </span>
        <span>
          <PrivacyPolicy />
        </span>
      </div>
    </div>
  );
};

export default LegalText;